import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'
import useIsMount from 'helpers/useIsMount'

import { NotFound } from 'js/core/NotFound'
import { MAGAZINE_ISSUE_VIEW } from 'js/magazine-issue/View/View.queries'

import Layout from './Layout/Layout'
import { MagazineViewProvider } from './MagazineViewContext'

const View = () => {
    const { containerGuid } = useParams()

    const { loading, data, refetch } = useQuery(MAGAZINE_ISSUE_VIEW, {
        variables: {
            guid: containerGuid,
        },
    })

    const isMount = useIsMount()
    useEffect(() => {
        if (isMount) {
            // Fetch all articles after creating a new article
            refetch()
        }
    }, [isMount, refetch])

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    return (
        <MagazineViewProvider value={{ entity: data.entity }}>
            <Layout />
        </MagazineViewProvider>
    )
}

export { MAGAZINE_ISSUE_VIEW }
export default View
